class StickyHeroActions extends HTMLElement {
  constructor() {
    super();
    this.preventStickyHeader();
  }

  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }

  connectedCallback() {
    this.heroSection = document.querySelector('.hero-product');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.hide();
        } else {
          this.show();
        }
      });
    }, {
      threshold: 0.1,
    });
    
    observer.observe(this.heroSection);
  }

  hide() {
    this.classList.remove('sticky-hero-actions--is-visible');
    document.body.classList.remove('sticky-hero-actions-padding');
  }

  show() {
    this.classList.add('sticky-hero-actions--is-visible');
    document.body.classList.add('sticky-hero-actions-padding');
  }
}

customElements.define('sticky-hero-actions', StickyHeroActions);

class HeroNavBar extends HTMLElement {
  connectedCallback() {
    this.heroImage = document.querySelector('.hero-product__hero-image img');
    this.detailsSection = document.getElementById('product-details');
    this.currentScrollTop = 0;
    this.currentHeight = this.offsetHeight;
    this.largeScreen = window.matchMedia("(min-width: 900px)").matches;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.largeScreen) {
      if (!document.querySelector('.hero-product-section').classList.contains('full-width')) {
        const imageOffset = Math.floor(scrollTop * 0.3);
        this.heroImage.style.transform = `translateY(-${imageOffset}px)`;
      }
    }

    if (scrollTop > this.detailsSection.offsetTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      requestAnimationFrame(this.hide.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.heroImage) {
      this.heroImage.style.display = 'block';
    }
  }

  reveal() {
    if (this.heroImage) {
      this.heroImage.style.display = 'none';
    }
  }
}

customElements.define('hero-nav-bar', HeroNavBar);
